import { cookieFactory } from '../lib/tools';

export default class BlockCookie {

  init() {
    this.clsActive = 'block-cookie--active';
    this.clsDismissed = 'block-cookie--dismissed';
    this.cookieName = 'privacy-notification';

    if (cookieFactory.get(this.cookieName) === '1') {
      this.close(true);
      return;
    } else {
      this.node.classList.add(this.clsActive);
    }

    this.outlets.confirm.addEventListener('click', () => {
      cookieFactory.set(this.cookieName, '1', 365);
      this.close();
    });

    this.outlets.close.addEventListener('click', () => {
      this.close();
    });
  }

  close(forceRemoval = false) {
    this.node.classList.add(this.clsDismissed);
    setTimeout(() => {
      this.node.remove();
    }, forceRemoval ? 0 : 1000);
  }

}
